type RGBType = { r: number; g: number; b: number }
export const hexToRgb = (hex: string): RGBType => {
  const bigint = parseInt(hex.replace('#', ''), 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return { r, g, b }
}

//as defined by: https://www.w3.org/WAI/GL/wiki/Relative_luminance
export const calcLuminance = ({ r, g, b }: RGBType): number => {
  const relativeRGB = [r, g, b].map(function (v) {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  return relativeRGB[0] * 0.2126 + relativeRGB[1] * 0.7152 + relativeRGB[2] * 0.0722
}

//takes in two hex and returns contrast ratio
//contrast ratio defined by https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
export function calcContrastRatio(hex1: string, hex2: string): number {
  const { r, g, b } = hexToRgb(hex1)
  const { r: r2, g: g2, b: b2 } = hexToRgb(hex2)
  const lum1 = calcLuminance({ r, g, b })
  const lum2 = calcLuminance({ r: r2, g: g2, b: b2 })
  const brightest = Math.max(lum1, lum2)
  const darkest = Math.min(lum1, lum2)
  return (brightest + 0.05) / (darkest + 0.05)
}

//contrast ratio against white
export function isContrastRatioScannable(hex: string): boolean {
  return calcContrastRatio(hex, '#ffffff') > 3.5
}
